import React from 'react'
import { View, Dimensions } from 'react-native'

const VimeoPlayer = () => {
	// Get screen dimensions for responsive sizing
	const { width } = Dimensions.get('window')
	const height = width * 0.5625 // 16:9 aspect ratio

	return (
		<View
			style={{
				width: '100%',
				height,
				overflow: 'hidden',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<iframe
				src={`https://player.vimeo.com/video/888815373?autoplay=1&muted=1&title=0&byline=0&portrait=0&controls=0&loop=1&background=1`}
				width="100%"
				height="100%"
				frameBorder="0"
				allow="autoplay; fullscreen"
				allowFullScreen
				style={{
					width: '100%',
					height: '100%',
					border: 'none',
					maxWidth: '100%',
					maxHeight: '100%',
				}}
			/>
		</View>
	)
}

export default VimeoPlayer
